import { createSelector } from 'reselect';

const getStatus = state => state.status;

export default props =>
  createSelector(getStatus, status => {
    if (Array.isArray(props)) {
      let obj = {};
      props.forEach(prop => {
        obj[prop] = status[prop];
      });
      return obj;
    }

    return {
      [props]: status[props],
    };
  });



// WEBPACK FOOTER //
// ./src/selector/status.js